import type { DeepPartial } from '@luna/utils-ts';

import type { RegularOrders } from '../../types/RegularOrders';

export const regularOrdersHRFeatureConfig: DeepPartial<RegularOrders> = {
    note: true,
    validFrom: true,
    validUntil: true,
};
